import { ButtonProps, Stack } from 'component-library';
import { ReactNode } from 'react';

import { ButtonWidget } from '@/components/widgets/a/Button/Button';

import { Icon } from '../Icon/Icon';
import { TextContainer } from '../Text/Text';

export type IconButtonWidgetProps = {
  icon: string;
  text?: string;
  i18nPath?: string;
  children?: ReactNode;
  direction?: 'row' | 'col' | 'row-reverse' | 'col-reverse';
  spacing?: number;
} & ButtonProps;

// TODO: MVP-CW shift to molecule
export const IconButtonWidget = ({
  icon,
  text,
  i18nPath,
  children,
  spacing = 1,
  direction = 'row',
  ...props
}: IconButtonWidgetProps) => {
  return (
    <ButtonWidget {...props}>
      <Stack direction={direction} spacing={spacing} centerMain>
        {icon && <Icon icon={icon} />}
        <TextContainer {...{ text, i18nPath, children }} />
      </Stack>
    </ButtonWidget>
  );
};
